//
// Imports
//

import * as BrowserUtilities from "@donutteam/browser-utilities";

//
// Get Release Summaries
//

export function initialiseReleaseSummary(releaseSummary: HTMLElement)
{
	const href = BrowserUtilities.ElementClientLib.getStringDataOrThrow(releaseSummary, "href");

	const isClickable = BrowserUtilities.ElementClientLib.getBooleanDataOrThrow(releaseSummary, "isClickable");

	if (isClickable)
	{
		releaseSummary.addEventListener("click", 
			(event) =>
			{
				if (event.target instanceof HTMLElement && event.target.closest("a") != null)
				{
					return;
				}
		
				window.location.href = href;
			});
	}

	releaseSummary.classList.add("initialised");
}

export function initialiseReleaseSummaries()
{
	const releaseSummaries = document.querySelectorAll<HTMLElement>(".component-release-summary:not(.initialised)");

	console.log("[ReleaseSummary] Initialising " + releaseSummaries.length + " instances...");

	for (const releaseSummary of releaseSummaries)
	{
		try
		{
			initialiseReleaseSummary(releaseSummary);
		}
		catch (error)
		{
			console.error("[ReleaseSummary] Error initialising:", releaseSummary, error);
		}
	}
}